// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .social-icon-container{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;gap:0!important;-webkit-box-pack:left!important;-ms-flex-pack:left!important;justify-content:left!important;margin-bottom:5px!important;margin-left:0!important}", ""]);
// Exports
module.exports = exports;
